import React from 'react';
const FuelCostResult = ({ fuelCost }) => {
  return (
    <div>
      <h2>តម្លៃប្រេងឥន្ធនៈ៖ ${fuelCost.toFixed(2)} </h2>  
    </div>
  );
};
export default FuelCostResult;
